/**
 * OTOMAX STORE — Smart Filter v7 (Robust Matching + Normalization)
 * assets/otomax-home-smart-filter.js
 *
 * Fokus perbaikan:
 * - Normalisasi string sebelum matching (case/space/dash/slash)
 * - Normalisasi rim (R18, 18, Ring 18 → dianggap sama)
 * - Normalisasi model mobil (HRV/HR-V, CX5/CX-5, Ioniq5/Ioniq 5, dll)
 * - Pakai brand_tag_prefix (sebelumnya tidak dipakai → banyak produk tidak match)
 * - Fallback jika data terstruktur tidak ada: masukkan ke query `q=`
 *
 * Catatan:
 * - Tetap memakai mekanisme native Shopify filter via URL querystring.
 * - Tidak mengubah struktur HTML/section schema.
 */
(function () {
  'use strict';

  /* ── CAR_DATA ─────────────────────────────────────────────────── */
  var CAR_DATA = {
    'Toyota': ['Agya', 'Agya GR', 'Alphard', 'Avanza', 'bZ4X', 'C-HR', 'Calya', 'Camry', 'Corolla', 'Corolla Altis', 'Corolla Cross', 'Fortuner', 'GR86', 'GR Supra', 'Hiace', 'Hilux', 'Innova', 'Innova Reborn', 'Innova Zenix', 'Kijang Innova', 'Land Cruiser', 'Prius', 'Raize', 'RAV4', 'Rush', 'Sienta', 'Vellfire', 'Veloz', 'Vios', 'Voxy', 'Yaris', 'Yaris Cross'],
    'Honda': ['Accord', 'Brio', 'Brio RS', 'BR-V', 'City', 'City Hatchback', 'Civic', 'Civic RS', 'Civic Type R', 'CR-V', 'Freed', 'HR-V', 'Jazz', 'Mobilio', 'Odyssey', 'Prelude', 'STEP WGN', 'WR-V'],
    'Daihatsu': ['Ayla', 'Ceria', 'Charade', 'Copen', 'Feroza', 'Gran Max', 'Himax', 'Luxio', 'Rocky', 'Sigra', 'Sirion', 'Taft', 'Taruna', 'Terios', 'Xenia'],
    'Mitsubishi': ['Colt FE', 'Delica', 'Eclipse Cross', 'Galant', 'Grandis', 'L300', 'Lancer', 'Mirage', 'Outlander', 'Pajero Sport', 'Triton', 'Xpander', 'Xpander Cross'],
    'Suzuki': ['APV', 'Baleno', 'Carry', 'Celerio', 'Ertiga', 'Escudo', 'Fronx', 'Grand Vitara', 'Hustler', 'Ignis', 'Jimny', 'Karimun', 'Karimun Estilo', 'S-Cross', 'Splash', 'Swift', 'SX4', 'Vitara', 'XL7'],
    'Nissan': ['Almera', 'Elgrand', 'Evalia', 'Grand Livina', 'Juke', 'Kicks e-Power', 'Latio', 'Leaf', 'Livina', 'Magnite', 'March', 'Navara', 'Patrol', 'Serena', 'Teana', 'Terra', 'X-Trail'],
    'Isuzu': ['D-Max', 'Elf', 'Giga', 'MU-X', 'Panther', 'Traga'],
    'Hyundai': ['Accent', 'Avega', 'Creta', 'Elantra', 'Grand Avega', 'H-1', 'i10', 'i20', 'Ioniq', 'Ioniq 5', 'Ioniq 6', 'KONA Electric', 'Palisade', 'Santa Fe', 'Sonata', 'Stargazer', 'Staria', 'Tucson'],
    'KIA': ['Carens', 'Carnival', 'EV6', 'Picanto', 'Rio', 'Seltos', 'Sonet', 'Sorento', 'Sportage', 'Stonic'],
    'Wuling': ['Air ev', 'Almaz', 'Alvez', 'BinguoEV', 'Cloud EV', 'Confero', 'Confero S', 'Cortez', 'Cortez S', 'Formo'],
    'DFSK': ['Gelora (ICE)', 'Gelora Electric (E)', 'Glory 500', 'Glory 560', 'Glory 580', 'Glory i-Auto', 'Seres 3', 'Seres 5', 'Seres 7', 'Seres E1', 'Supercab'],
    'BAIC': ['BJ30', 'BJ40', 'BJ40 Plus', 'BJ80', 'M50S', 'M60', 'MX5', 'X35', 'X55'],
    'MG': ['MG 4 EV', 'MG 5 GT', 'MG Cyberster', 'MG HS', 'MG ZS', 'MG ZS EV', 'MGS5 EV', 'VS EV', 'VS HEV', 'ZS', 'ZS EV'],
    'BYD': ['Atto 1', 'Atto 3', 'Dolphin', 'Han EV', 'M6', 'Seal', 'Sealion 6', 'Sealion 7'],
    'Denza': ['D9'],
    'Chery': ['Chery C5', 'Chery E5', 'Chery J6', 'Omoda 5', 'Omoda 5 EV', 'Omoda 5 GT', 'Omoda E5', 'Tiggo 4 Pro', 'Tiggo 5X', 'Tiggo 7 Pro', 'Tiggo 8', 'Tiggo 8 CSH', 'Tiggo 8 Pro', 'Tiggo 8 Pro Max', 'Tiggo 9 CSH', 'Tiggo Cross', 'Tiggo Cross CSH', 'Tiggo Cross Sport'],
    'Haval': ['Dargo', 'H6', 'H9', 'Jolion'],
    'GWM': ['Poer', 'Tank 300', 'Tank 500', 'Tank300', 'Tank500'],
    'Geely': ['Coolray', 'Emgrand', 'EX5', 'GX3 Pro', 'Starray'],
    'Mazda': ['Biante', 'BT-50', 'CX-3', 'CX-30', 'CX-5', 'CX-8', 'CX-9', 'CX-60', 'CX-90', 'Mazda 2', 'Mazda 3', 'Mazda 6', 'MX-5'],
    'Subaru': ['BRZ', 'Crosstrek', 'Forester', 'Impreza', 'Levorg', 'Outback', 'WRX', 'XV'],
    'Chevrolet': ['Aveo', 'Blazer', 'Captiva', 'Colorado', 'Cruze', 'Orlando', 'Spin', 'Trailblazer', 'Trax'],
    'BMW': ['118i', '120i', '218i', '220i', '320i', '325i', '328i', '330i', '340i', '430i', '520i', '530i', '740i', '5 Series (G30)', '7 Series (G11/G12)', 'i4', 'i5', 'i7', 'iX', 'iX1', 'iX3', 'M3', 'M5', 'Seri 3', 'Seri 5', 'Seri 7', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'XM', 'Z4'],
    'Mercedes Benz': ['A-Class', 'B-Class', 'C-Class', 'C200', 'C300', 'CLA', 'E-Class', 'E200', 'E300', 'EQA', 'EQB', 'EQC', 'EQE', 'EQS', 'G-Class', 'GLA', 'GLA AMG 35', 'GLA AMG 45', 'GLB', 'GLC', 'GLE', 'GLS', 'S-Class', 'V-Class'],
    'Audi': ['A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'e-tron', 'Q2', 'Q3', 'Q5', 'Q7', 'Q8', 'RS5', 'TT'],
    'Volkswagen': ['Beetle', 'Caravelle', 'Golf', 'ID.4', 'Passat', 'Polo', 'Scirocco', 'Sharan', 'T-Roc', 'Tiguan', 'Touareg', 'Touran'],
    'Lexus': ['ES', 'GS', 'IS', 'Lexus ES 250', 'Lexus ES 350', 'Lexus GS 300H', 'Lexus IS', 'Lexus IS 350', 'Lexus LM', 'Lexus LS', 'Lexus LX', 'Lexus RX', 'Lexus UX', 'NX', 'NX 300h', 'NX 350', 'RX', 'RX 300', 'RX 350', 'RX 450h', 'RZ'],
    'Porsche': ['718', '718 Boxster', '718 Cayman', '911', 'Boxster', 'Cayenne', 'Macan', 'Panamera', 'Porsche 718 Cayman', 'Taycan'],
    'Land Rover': ['Defender', 'Discovery', 'Discovery Sport', 'Freelander', 'Range Rover', 'Range Rover Evoque', 'Range Rover Sport', 'Range Rover Velar'],
    'Jeep': ['Cherokee', 'Compass', 'Grand Cherokee', 'Renegade', 'Wrangler'],
    'Ford': ['Bronco', 'EcoSport', 'Escape', 'Everest', 'Explorer', 'F-150 Raptor', 'Fiesta', 'Focus', 'Ranger'],
    'Volvo': ['C40', 'EX30', 'EX40', 'S60', 'S90', 'XC40', 'XC60', 'XC90'],
    'Mitsubishi Fuso': ['Canter', 'Fighter', 'FN', 'FO'],
    'Hino': ['300 Series', '500 Series', 'Dutro', 'Ranger'],
    'Jetour': ['Dashing', 'Jetour J2', 'T2', 'X70', 'X70 Plus'],
    'ORA': ['Ora 03'],
    'Xpeng': ['G6', 'P7', 'X9'],
    'GAC': ['AION UT', 'AION V', 'AION Y Plus', 'HYPTEC HT'],
    'Neta': ['V', 'V-II (V2)', 'X'],
    'Changan': ['Avatr', 'Deepal', 'Deepal S05', 'Deepal S07', 'Lumin', 'Nevo (Qiyuan)', 'UNI'],
    'Jaecoo': ['J5', 'J5 EV', 'J7', 'J7 SHS', 'J8'],
    'MINI': ['Clubman', 'Cooper', 'Cooper S', 'Countryman', 'MINI Cooper', 'MINI Cooper SE', 'Paceman'],
    'Tesla': ['Model 3', 'Model S', 'Model X', 'Model Y'],
    'Peugeot': ['2008', '3008', '5008', 'e-2008'],
    'Citroen': ['C3', 'C5 Aircross', 'E-C3', 'E-Berlingo'],
    'Renault': ['Captur', 'Duster', 'Koleos', 'Triber']
  };

  /* ── VENDOR_DATA (brand produk + logo per collection) ─────────── */
  var VENDOR_DATA = {
    'ban-mobil': [
      { name: 'Michelin', img: 'https://otomax.store/cdn/shop/collections/MICHELIN.webp?width=80' },
      { name: 'Pirelli', img: 'https://otomax.store/cdn/shop/collections/ban-pirreli.webp?width=80' },
      { name: 'Continental', img: 'https://otomax.store/cdn/shop/collections/continental.webp?width=80' },
      { name: 'Bridgestone', img: 'https://otomax.store/cdn/shop/collections/ban-bridgestone.webp?width=80' },
      { name: 'Yokohama', img: 'https://otomax.store/cdn/shop/collections/ban-yokohama.webp?width=80' },
      { name: 'Dunlop', img: 'https://otomax.store/cdn/shop/collections/ban-dunlop.webp?width=80' },
      { name: 'BF Goodrich', img: 'https://otomax.store/cdn/shop/collections/ban-bfgoodrich.webp?width=80' },
      { name: 'Delium', img: 'https://otomax.store/cdn/shop/collections/delium.webp?width=80' },
      { name: 'Falken', img: 'https://otomax.store/cdn/shop/collections/ban-falken.webp?width=80' },
      { name: 'Forceum', img: 'https://cdn.shopify.com/s/files/1/0600/7514/7334/files/forceum.jpg?width=80' },
      { name: 'Giti', img: 'https://otomax.store/cdn/shop/collections/giti-logo.svg' },
      { name: 'Goodyear', img: 'https://otomax.store/cdn/shop/collections/ban-goodyear.webp?width=80' },
      { name: 'GT Radial', img: 'https://otomax.store/cdn/shop/collections/ban-gtradial.webp?width=80' },
      { name: 'Hankook', img: 'https://otomax.store/cdn/shop/collections/hankook.webp?width=80' },
      { name: 'Kanati', img: 'https://otomax.store/cdn/shop/collections/kanati.webp?width=80' },
      { name: 'Kumho', img: 'https://otomax.store/cdn/shop/collections/kumho.webp?width=80' },
      { name: 'Maxxis', img: 'https://otomax.store/cdn/shop/collections/ban-maxxis.webp?width=80' },
      { name: 'Mickey Thompson', img: 'https://cdn.shopify.com/s/files/1/0600/7514/7334/files/Mickey-Thomson.png?width=80' },
      { name: 'Nankang', img: 'https://otomax.store/cdn/shop/collections/NANKANG.webp?width=80' },
      { name: 'Nexen', img: 'https://cdn.shopify.com/s/files/1/0600/7514/7334/files/nexen-tire.png?width=80' },
      { name: 'Sailun', img: 'https://cdn.shopify.com/s/files/1/0600/7514/7334/files/Saliun-tire.png?width=80' },
      { name: 'Accelera', img: 'https://cdn.shopify.com/s/files/1/0600/7514/7334/files/LOGO_ACCELERA.png?width=80' },
      { name: 'Toyo', img: 'https://cdn.shopify.com/s/files/1/0600/7514/7334/files/Toyo-tire.png?width=80' }
    ],
    'velg-mobil': [
      { name: 'Lenso', img: 'https://otomax.store/cdn/shop/files/velg-lenso.webp?width=80' },
      { name: 'Rotiform', img: 'https://otomax.store/cdn/shop/collections/rotiform.webp?width=80' },
      { name: 'Konig', img: 'https://otomax.store/cdn/shop/collections/velg-konig.webp?width=80' },
      { name: 'Enkei', img: 'https://otomax.store/cdn/shop/collections/velg-enkei.webp?width=80' },
      { name: 'Niche', img: 'https://otomax.store/cdn/shop/collections/velg-nichewheel.webp?width=80' },
      { name: 'American Racing', img: 'https://otomax.store/cdn/shop/collections/velg-americanracing.webp?width=80' },
      { name: 'SSW', img: 'https://otomax.store/cdn/shop/collections/velg-ssw.webp?width=80' },
      { name: 'BBS', img: 'https://otomax.store/cdn/shop/collections/BBS-Logo-2048x1152.webp?width=80' },
      { name: 'Advanti', img: 'https://otomax.store/cdn/shop/collections/advanti.webp?width=80' },
      { name: 'Oz', img: 'https://otomax.store/cdn/shop/collections/velg-ozracing.webp?width=80' },
      { name: 'Motegi', img: 'https://otomax.store/cdn/shop/collections/velg-motegi.webp?width=80' },
      { name: 'Sparco', img: 'https://otomax.store/cdn/shop/collections/Sparco_Wheels_Logo-2048x691.webp?width=80' },
      { name: 'SSR', img: 'https://otomax.store/cdn/shop/collections/download.png' },
      { name: 'Torsion', img: 'https://otomax.store/cdn/shop/collections/velg-torsion.webp?width=80' },
      { name: 'Fuel', img: 'https://otomax.store/cdn/shop/collections/velg-fuel.webp?width=80' },
      { name: 'Vertini', img: 'https://otomax.store/cdn/shop/collections/vertini.webp?width=80' },
      { name: 'Vossen', img: 'https://otomax.store/cdn/shop/collections/vossen-1.webp?width=80' },
      { name: 'Work', img: 'https://otomax.store/cdn/shop/collections/velg-workwheels.webp?width=80' },
      { name: 'XD KMC', img: 'https://otomax.store/cdn/shop/collections/velg-xdkmc.webp?width=80' },
      { name: 'Breyton', img: 'https://otomax.store/cdn/shop/collections/Desain_tanpa_judul_34.png?width=80' },
      { name: 'ADV-1', img: '' },
      { name: 'Advan Racing', img: '' },
      { name: 'Black Rhino', img: '' },
      { name: 'Rays', img: '' },
      { name: 'Volk Racing Wheel', img: '' },
      { name: 'Weds', img: '' },
      { name: 'Weds Sport', img: '' },
      { name: 'Vorsteiner', img: '' },
      { name: 'ESR Wheels', img: '' }
    ]
  };

  /* ── UTIL ─────────────────────────────────────────────────────── */
  function nrm(v) {
    return (v || '').toLowerCase().trim();
  }

  function normalizeText(v) {
    return String(v || '')
      .toLowerCase()
      .trim()
      .replace(/[‐‑‒–—−]/g, '-')       // normalisasi berbagai dash unicode → "-"
      .replace(/[’'`]/g, '')           // buang variasi apostrophe
      .replace(/[^\S\r\n]+/g, ' ')     // double spaces → single space
      .replace(/\s*\/\s*/g, '/')       // spasi di sekitar slash
      .replace(/\s*-\s*/g, '-')        // spasi di sekitar dash
      .replace(/\s*\|\s*/g, '|');      // spasi di sekitar pipe
  }

  function normalizeKey(v) {
    return normalizeText(v).replace(/[^a-z0-9]/g, '');
  }

  function escapeRegExp(s) {
    return String(s || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Alias model mobil untuk menyamakan variasi penulisan umum
  function canonicalModelKey(v) {
    var k = normalizeKey(v);
    var alias = {
      // Pajero / Montero
      'monterosport': 'pajerosport',
      'pajero': 'pajerosport',

      // HRV / HR-V
      'hrv': 'hrv',

      // CX5 / CX-5
      'cx5': 'cx5',

      // Ioniq5 / Ioniq 5
      'ioniq5': 'ioniq5',

      // Innova Reborn / Kijang Innova Reborn
      'kijanginnovareborn': 'innovareborn',
      'innovareborn': 'innovareborn',

      // Sealion/Sealion 6/Sealion 7 → biarkan (tidak disatukan)
    };
    return alias[k] || k;
  }

  function normalizeRimKey(v) {
    var t = normalizeText(v).toUpperCase();
    // ambil angka ring 12-26 (umum untuk mobil)
    var m =
      t.match(/\bR\s*([0-9]{2})\b/i) ||
      t.match(/\bRING\s*([0-9]{2})\b/i) ||
      t.match(/\b([0-9]{2})\b/);

    if (!m) return '';
    var num = parseInt(m[1], 10);
    if (isNaN(num) || num < 10 || num > 30) return '';
    return 'r' + num;
  }

  function rimLabelFromKey(rk) {
    var m = String(rk || '').match(/^r(\d{2})$/i);
    return m ? ('R' + m[1]) : String(rk || '');
  }

  function normalizePcdKey(v) {
    // contoh: "5x114,3" vs "5x114.3" vs "5 x 114.3"
    return normalizeText(v)
      .replace(/×/g, 'x')
      .replace(/,/g, '.')
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9x.]/g, '');
  }

  function normalizeKeywordQuery(q) {
    // Jika terdeteksi format ukuran ban, ubah jadi token konsisten
    // 225/45 R18, 225/45R18, 225 45 R18, 225/45-18 → "225 45 r18"
    var raw = String(q || '').trim();
    if (!raw) return '';

    var s = raw.toLowerCase().replace(/,/g, '.');
    var m = s.match(/(\d{3})\s*(?:\/|\s)\s*(\d{2})\s*(?:r|R|\-|\s)\s*([1-3]\d)\b/);
    if (m) {
      return (m[1] + ' ' + m[2] + ' r' + m[3]).trim();
    }
    // fallback: minimal normalisasi spasi/dash/slash
    return normalizeText(raw);
  }

  // urlKey dipakai untuk nama option (bagian KEY querystring)
  function urlKey(n) {
    return (n || '')
      .trim()
      .toLowerCase()
      .split('')
      .map(function (c) {
        if (c === ' ') return '+';
        if (c === '|') return '%7C';
        return /[a-z0-9\-_.]/.test(c) ? c : encodeURIComponent(c);
      })
      .join('');
  }

  function getOpts(product, optName) {
    if (!product || !Array.isArray(product.variants)) return [];
    var idx = -1,
      src = product.options_with_values || product.options || [];
    for (var i = 0; i < src.length; i++) {
      var nm = typeof src[i] === 'string' ? src[i] : src[i] && src[i].name ? src[i].name : '';
      if (nrm(nm) === nrm(optName)) {
        idx = i;
        break;
      }
    }
    if (idx < 0) return [];
    var k = 'option' + (idx + 1),
      seen = {},
      res = [];
    product.variants.forEach(function (v) {
      var x = v && v[k];
      if (x && !seen[x]) {
        seen[x] = 1;
        res.push(String(x).trim());
      }
    });
    return res;
  }

  function parseTags(tags) {
    // /products.json biasanya mengembalikan tags sebagai string "a, b, c"
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(function (t) { return String(t || '').trim(); }).filter(Boolean);
    return String(tags)
      .split(',')
      .map(function (t) { return String(t || '').trim(); })
      .filter(Boolean);
  }

  function sortRimKeys(keys) {
    return (keys || []).slice().sort(function (a, b) {
      var na = parseInt(String(a).replace(/\D/g, ''), 10);
      var nb = parseInt(String(b).replace(/\D/g, ''), 10);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      return String(a).localeCompare(String(b));
    });
  }

  /* ── LIGHTWEIGHT COMBOBOX ─────────────────────────────────────── */
  function makeCombo(wrap, onSelect) {
    var inp = wrap.querySelector('[data-ci]'); /* input */
    var drop = wrap.querySelector('[data-cd]'); /* dropdown */
    var arr = wrap.querySelector('[data-ca]'); /* arrow icon */
    var items = [],
      chosen = '',
      open = false;

    function draw(q) {
      var f = q ? items.filter(function (i) { return nrm(i).indexOf(nrm(q)) >= 0; }) : items;
      drop.innerHTML = '';
      if (!f.length) {
        drop.innerHTML = '<div class="cb-empty">Tidak ditemukan</div>';
        return;
      }
      f.forEach(function (item) {
        var d = document.createElement('div');
        d.className = 'cb-opt' + (item === chosen ? ' cb-sel' : '');
        d.textContent = item;
        d.addEventListener('mousedown', function (e) {
          e.preventDefault();
          pick(item);
        });
        drop.appendChild(d);
      });
    }

    function show() {
      open = true;
      wrap.classList.add('cb-open');
      if (arr) arr.style.transform = 'rotate(180deg)';
      draw(inp.value);
    }
    function hide() {
      open = false;
      wrap.classList.remove('cb-open');
      if (arr) arr.style.transform = '';
      inp.value = chosen;
    }
    function pick(v) {
      chosen = v;
      inp.value = v;
      hide();
      if (onSelect) onSelect(v);
    }
    function reset(pl) {
      chosen = '';
      inp.value = '';
      inp.placeholder = pl || inp.placeholder;
      inp.disabled = true;
      items = [];
      drop.innerHTML = '';
      hide();
    }
    function load(list, pl) {
      items = (list || []).slice().sort(function (a, b) { return a.localeCompare(b); });
      chosen = '';
      inp.value = '';
      inp.disabled = !items.length;
      if (pl) inp.placeholder = pl;
    }

    inp.addEventListener('click', function () {
      !inp.disabled && (open ? hide() : show());
    });
    inp.addEventListener('input', function () {
      if (!open) show();
      else draw(inp.value);
    });
    inp.addEventListener('blur', function () {
      setTimeout(hide, 160);
    });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hide();
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var opts = drop.querySelectorAll('.cb-opt'),
          cur = -1;
        opts.forEach(function (o, i) {
          if (o.classList.contains('cb-hi')) cur = i;
        });
        opts.forEach(function (o) { o.classList.remove('cb-hi'); });
        if (!opts.length) return;
        var nx = e.key === 'ArrowDown' ? (cur + 1) % opts.length : (cur - 1 + opts.length) % opts.length;
        if (opts[nx]) {
          opts[nx].classList.add('cb-hi');
          opts[nx].scrollIntoView({ block: 'nearest' });
        }
      }
      if (e.key === 'Enter') {
        var hi = drop.querySelector('.cb-hi');
        if (hi) hi.dispatchEvent(new MouseEvent('mousedown'));
      }
    });

    return { load: load, reset: reset, val: function () { return chosen; }, pick: pick };
  }

  /* ── BRAND LOGO DROPDOWN ──────────────────────────────────────── */
  function makeBrandDrop(wrap, onSelect) {
    var btn = wrap.querySelector('[data-bt]');
    var lbl = wrap.querySelector('[data-bl]');
    var drop = wrap.querySelector('[data-bd]');
    var srch = wrap.querySelector('[data-bs]');
    var list = wrap.querySelector('[data-blist]');
    var items = [],
      chosen = '',
      open = false;

    function abbr(n) {
      return n.replace(/[aeiou\s]/gi, '').substring(0, 3).toUpperCase() || n.substring(0, 3).toUpperCase();
    }

    function draw(q) {
      q = nrm(q || '');
      var f = q ? items.filter(function (i) { return nrm(i.name).indexOf(q) >= 0; }) : items;
      list.innerHTML = '';
      /* Semua */
      var all = document.createElement('div');
      all.className = 'bd-opt' + (chosen === '' ? ' bd-sel' : '');
      all.innerHTML = '<span class="bd-noimg">ALL</span><span class="bd-nm">Semua Brand</span>';
      all.addEventListener('mousedown', function (e) {
        e.preventDefault();
        pick('');
      });
      list.appendChild(all);

      f.forEach(function (it) {
        var d = document.createElement('div');
        d.className = 'bd-opt' + (it.name === chosen ? ' bd-sel' : '');
        if (it.img) {
          d.innerHTML = '<img src="' + it.img + '" alt="' + it.name + '" class="bd-img" loading="lazy"><span class="bd-nm">' + it.name + '</span>';
        } else {
          d.innerHTML = '<span class="bd-noimg">' + abbr(it.name) + '</span><span class="bd-nm">' + it.name + '</span>';
        }
        d.addEventListener('mousedown', function (e) {
          e.preventDefault();
          pick(it.name);
        });
        list.appendChild(d);
      });
    }

    function show() {
      open = true;
      wrap.classList.add('bd-open');
      if (srch) {
        srch.value = '';
        setTimeout(function () { srch.focus(); }, 50);
      }
      draw('');
    }
    function hide() {
      open = false;
      wrap.classList.remove('bd-open');
    }
    function pick(v) {
      chosen = v;
      lbl.className = 'bd-label' + (v ? '' : ' bd-ph');
      if (v) {
        var found = items.find(function (i) { return i.name === v; });
        lbl.innerHTML = (found && found.img ? '<img src="' + found.img + '" class="bd-thumb" alt="' + v + '">' : '') + v;
      } else {
        lbl.textContent = 'Semua Brand Produk';
      }
      hide();
      if (onSelect) onSelect(v);
    }
    function load(list_) {
      items = list_ || [];
      chosen = '';
      lbl.className = 'bd-label bd-ph';
      lbl.textContent = 'Semua Brand Produk';
    }

    btn.addEventListener('click', function () { open ? hide() : show(); });
    document.addEventListener('click', function (e) {
      if (open && !wrap.contains(e.target)) hide();
    });
    if (srch) {
      srch.addEventListener('input', function () { draw(srch.value); });
      srch.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    }

    return { load: load, val: function () { return chosen; } };
  }

  /* ── INIT SECTION ─────────────────────────────────────────────── */
  function initSection(sec) {
    if (!sec || sec.dataset.osfInitialized === 'true') return;
    sec.dataset.osfInitialized = 'true';

    var tabs = sec.querySelectorAll('[data-tab-button]');
    var bcWrap = sec.querySelector('[data-brand-combo]');
    var tcWrap = sec.querySelector('[data-type-combo]');
    var vdWrap = sec.querySelector('[data-vendor-combo]');
    var kwInp = sec.querySelector('[data-keyword-input]');
    var profSel = sec.querySelector('[data-profile-select]');
    var sortSel = sec.querySelector('[data-sort-select]');
    var rimGrp = sec.querySelector('[data-rim-group]');
    var applyBtn = sec.querySelector('[data-apply-button]');
    var statusEl = sec.querySelector('[data-status]');

    if (!bcWrap || !rimGrp || !applyBtn) return;

    var rimOpt = (sec.dataset.rimOptionName || 'Rim Size').trim();
    var profOpt = (sec.dataset.profileOptionName || 'PCD-Width | Profile').trim();
    var typeOpt = (sec.dataset.carTypeOptionName || 'Tipe Mobil').trim();
    var profLbl = sec.dataset.profileLabel || 'Profile / PCD';
    var brandTagPrefix = (sec.dataset.brandTagPrefix || '').trim();

    var rimKeyParam = urlKey(rimOpt),
      profKeyParam = urlKey(profOpt),
      typeKeyParam = urlKey(typeOpt);

    var colUrl = '';
    var selectedRimKey = ''; // contoh: "r18"

    // Index dari produk (dibangun per tab collection)
    var idx = {
      rim: {},        // rimKey -> [actualValues]
      type: {},       // modelKey -> [actualValues]
      profile: {},    // profKey -> [actualValues]
      tagByBrandKey: {}, // brandKey -> actualTag
      optionHasType: false,
      optionHasRim: false,
      optionHasProfile: false
    };

    var brandNames = Object.keys(CAR_DATA).sort(function (a, b) { return a.localeCompare(b); });
    var bc = makeCombo(bcWrap, function (v) {
      if (tc) tc.reset('Pilih Tipe Mobil');
      if (v && CAR_DATA[v]) tc && tc.load(CAR_DATA[v], 'Pilih Tipe Mobil');
    });
    var tc = tcWrap ? makeCombo(tcWrap, function () { }) : null;
    var vd = vdWrap ? makeBrandDrop(vdWrap, function () { }) : null;

    bc.load(brandNames, 'Pilih Merek Mobil');

    function st(t) { if (statusEl) statusEl.textContent = t || ''; }

    function fillSel(sel, ph, arr) {
      var prev = sel.value;
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = '';
      o.textContent = ph;
      sel.appendChild(o);
      (arr || []).forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v;
        opt.textContent = v;
        sel.appendChild(opt);
      });
      if (arr && arr.indexOf(prev) >= 0) sel.value = prev;
    }

    function drawRims(rimKeys) {
      rimGrp.innerHTML = '';
      var keys = sortRimKeys(rimKeys || []);
      // Tambah "Semua" di depan
      [''].concat(keys).forEach(function (rk) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'otomax-smart-filter__rim' + (rk === selectedRimKey ? ' is-active' : '');
        b.textContent = rk ? rimLabelFromKey(rk) : 'Semua';
        b.dataset.rim = rk; // simpan rimKey, bukan nilai raw produk
        rimGrp.appendChild(b);
      });
    }

    function addParam(list, key, value) {
      list.push(key + '=' + encodeURIComponent(value));
    }

    function findBrandTag(brand) {
      var bKey = normalizeKey(brand);
      if (!bKey) return '';

      // Prioritas: kalau ada prefix, cari tag berdasarkan suffix setelah prefix
      if (brandTagPrefix) {
        var byPrefix = idx.tagByBrandKey[bKey];
        if (byPrefix) return byPrefix;
      }

      // Fallback: kalau ada tag "Toyota" langsung (tanpa prefix)
      // Kita coba cari "Toyota" tepat (case/space/dash diabaikan)
      return idx.tagByBrandKey[bKey] || '';
    }

    function getActualTypeValues(type) {
      var key = canonicalModelKey(type);
      var arr = idx.type[key];
      return Array.isArray(arr) ? arr.slice() : [];
    }

    function getActualRimValues(rimKey) {
      var arr = idx.rim[rimKey];
      return Array.isArray(arr) ? arr.slice() : [];
    }

    function getActualProfileValues(profileVal) {
      var k = normalizePcdKey(profileVal);
      var arr = idx.profile[k];
      return Array.isArray(arr) ? arr.slice() : [];
    }

    function buildURL() {
      if (!colUrl) return '#';

      var p = [];
      var qTokens = [];

      var brand = bc.val();
      var type = tc ? tc.val() : '';
      var vendor = vd ? vd.val() : '';
      var prof = profSel ? profSel.value.trim() : '';
      var sort = sortSel ? sortSel.value : '';
      var rawKw = kwInp ? kwInp.value.trim() : '';

      // 1) Sort
      if (sort && sort !== 'featured') p.push('sort_by=' + encodeURIComponent(sort));
      else p.push('sort_by=created-descending');

      // 2) Vendor / Brand produk
      if (vendor) p.push('filter.p.vendor=' + encodeURIComponent(vendor));

      // 3) Price kosong tetap dimasukkan (agar konsisten dengan Search & Discovery)
      p.push('filter.v.price.gte=');
      p.push('filter.v.price.lte=');

      // 4) Brand mobil: pakai tag jika tersedia, kalau tidak → fallback ke q
      if (brand) {
        var brandTag = findBrandTag(brand);
        if (brandTag) {
          addParam(p, 'filter.p.tag', brandTag);
        } else {
          qTokens.push(brand);
        }
      }

      // 5) Tipe mobil: pakai option jika tersedia, kalau tidak → fallback ke q
      if (type) {
        var typeValues = idx.optionHasType ? getActualTypeValues(type) : [];
        if (typeValues.length) {
          typeValues.forEach(function (v) {
            addParam(p, 'filter.v.option.' + typeKeyParam, v);
          });
        } else {
          qTokens.push(type);
        }
      }

      // 6) Rim size: gunakan normalisasi rimKey agar 18/R18/Ring 18 bisa dianggap sama.
      if (selectedRimKey) {
        var rimValues = idx.optionHasRim ? getActualRimValues(selectedRimKey) : [];
        if (rimValues.length) {
          rimValues.forEach(function (v) {
            addParam(p, 'filter.v.option.' + rimKeyParam, v);
          });
        } else {
          qTokens.push(rimLabelFromKey(selectedRimKey));
        }
      }

      // 7) Profile / PCD: tetap pakai option, namun disamakan "5x114,3" vs "5x114.3"
      if (prof) {
        var profValues = idx.optionHasProfile ? getActualProfileValues(prof) : [];
        if (profValues.length) {
          profValues.forEach(function (v) {
            addParam(p, 'filter.v.option.' + profKeyParam, v);
          });
        } else {
          qTokens.push(prof);
        }
      }

      // 8) Keyword input: normalisasi ukuran ban (kalau ada), lalu gabungkan dengan fallback tokens
      if (rawKw) qTokens.unshift(normalizeKeywordQuery(rawKw));
      qTokens = qTokens.filter(Boolean);
      if (qTokens.length) addParam(p, 'q', qTokens.join(' '));

      return colUrl + (p.length ? '?' + p.join('&') : '');
    }

    function go() {
      var u = buildURL();
      if (u && u !== '#') window.location.href = u;
    }

    function fetchAllProducts(page, all) {
      all = all || [];
      page = page || 1;

      return fetch(colUrl + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(function (d) {
          var ps = (d && d.products) || [];
          all = all.concat(ps);
          // Shopify mengembalikan <=250 per halaman. Jika penuh 250, kemungkinan masih ada halaman berikutnya.
          if (ps.length === 250) return fetchAllProducts(page + 1, all);
          return all;
        });
    }

    function buildIndexesFromProducts(products) {
      idx = {
        rim: {},
        type: {},
        profile: {},
        tagByBrandKey: {},
        optionHasType: false,
        optionHasRim: false,
        optionHasProfile: false
      };

      // Brand tag prefix (case-insensitive)
      var prefix = brandTagPrefix;
      var rePrefix = prefix ? new RegExp('^' + escapeRegExp(prefix), 'i') : null;

      // Temporary sets untuk dedupe
      var rimKeysSet = {};
      var profKeysSet = {};

      products.forEach(function (p) {
        // Tags
        parseTags(p.tags).forEach(function (tag) {
          var t = String(tag || '').trim();
          if (!t) return;

          if (rePrefix && rePrefix.test(t)) {
            var suffix = t.replace(rePrefix, '').trim();
            var bKey = normalizeKey(suffix);
            if (bKey && !idx.tagByBrandKey[bKey]) idx.tagByBrandKey[bKey] = t;
          } else {
            // juga simpan tag "langsung" (tanpa prefix) agar tetap bisa dipakai
            var directKey = normalizeKey(t);
            if (directKey && !idx.tagByBrandKey[directKey]) idx.tagByBrandKey[directKey] = t;
          }
        });

        // Rim option
        var rims = getOpts(p, rimOpt);
        if (rims.length) idx.optionHasRim = true;
        rims.forEach(function (v) {
          var rk = normalizeRimKey(v);
          if (!rk) return;
          rimKeysSet[rk] = 1;
          if (!idx.rim[rk]) idx.rim[rk] = [];
          if (idx.rim[rk].indexOf(v) < 0) idx.rim[rk].push(v);
        });

        // Profile option
        var profs = getOpts(p, profOpt);
        if (profs.length) idx.optionHasProfile = true;
        profs.forEach(function (v) {
          var pk = normalizePcdKey(v);
          if (!pk) return;
          profKeysSet[pk] = 1;
          if (!idx.profile[pk]) idx.profile[pk] = [];
          if (idx.profile[pk].indexOf(v) < 0) idx.profile[pk].push(v);
        });

        // Type option
        var types = getOpts(p, typeOpt);
        if (types.length) idx.optionHasType = true;
        types.forEach(function (v) {
          var tk = canonicalModelKey(v);
          if (!tk) return;
          if (!idx.type[tk]) idx.type[tk] = [];
          if (idx.type[tk].indexOf(v) < 0) idx.type[tk].push(v);
        });
      });

      var rimKeys = Object.keys(rimKeysSet);
      var profVals = [];
      Object.keys(profKeysSet).forEach(function (k) {
        // pilih 1 value representatif (yang pertama)
        var arr = idx.profile[k] || [];
        if (arr[0]) profVals.push(arr[0]);
      });

      // Rim pills sudah dinormalisasi jadi Rxx
      drawRims(rimKeys);

      if (profSel) {
        fillSel(
          profSel,
          profLbl,
          profVals.sort(function (a, b) {
            return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
          })
        );
      }
    }

    function loadCol(handle, label, searchPlaceholder) {
      if (!handle) {
        st('Collection belum dipilih.');
        return;
      }

      colUrl = '/collections/' + handle;
      selectedRimKey = '';

      bc.load(brandNames, 'Pilih Merek Mobil');
      if (tc) tc.reset('Pilih Tipe Mobil');
      if (vd) vd.load(VENDOR_DATA[handle] || []);
      if (profSel) fillSel(profSel, profLbl, []);
      if (kwInp) {
        kwInp.value = '';
        if (searchPlaceholder) kwInp.setAttribute('placeholder', searchPlaceholder);
      }
      if (sortSel) sortSel.value = 'created-descending';

      rimGrp.innerHTML = '';
      st('Memuat filter…');

      fetchAllProducts(1, [])
        .then(function (ps) {
          if (!ps.length) {
            drawRims([]);
            st('Belum ada produk.');
            return;
          }
          buildIndexesFromProducts(ps);

          // Status: info bila data wajib tidak lengkap
          var warn = [];
          if (!idx.optionHasRim) warn.push('Rim Size');
          if (!idx.optionHasType) warn.push('Tipe Mobil');
          if (!idx.optionHasProfile) {
            // profile optional, jadi jangan terlalu “menakuti”
          }

          if (warn.length) {
            st('Filter siap untuk ' + label + '. (Catatan: beberapa produk belum punya data: ' + warn.join(', ') + ')');
          } else {
            st('Filter siap untuk ' + label + '.');
          }
        })
        .catch(function () {
          drawRims([]);
          st('Gagal memuat filter.');
        });
    }

    /* events */
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        selectedRimKey = '';
        loadCol(b.dataset.collectionHandle, b.dataset.tabLabel || b.textContent.trim(), b.dataset.searchPlaceholder || '');
      });
    });

    rimGrp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rim]');
      if (!b) return;
      selectedRimKey = b.dataset.rim || '';
      rimGrp.querySelectorAll('[data-rim]').forEach(function (x) {
        x.classList.toggle('is-active', x.dataset.rim === selectedRimKey);
      });
    });

    if (kwInp)
      kwInp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          go();
        }
      });
    var si = sec.querySelector('.otomax-smart-filter__search-icon');
    if (si) si.addEventListener('click', go);
    applyBtn.addEventListener('click', go);

    var ft = sec.querySelector('[data-tab-button][data-collection-handle]');
    if (ft && ft.dataset.collectionHandle)
      loadCol(ft.dataset.collectionHandle, ft.dataset.tabLabel || ft.textContent.trim(), ft.dataset.searchPlaceholder || '');
    else st('Pilih collection di pengaturan section.');
  }

  function initAll(r) { (r || document).querySelectorAll('.otomax-smart-filter').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();

